enum GuiOptions {
  admin = 'admin',
  reports = 'reports',
  permissionerror = 'permissionerror',
  user = 'user'
}

function asGuiOptions(str?: string): GuiOptions {
  if (str === GuiOptions.admin) {
    return GuiOptions.admin
  } else if (str === GuiOptions.reports) {
    return GuiOptions.reports
  } else if (str === 'permissionerror') {
    return GuiOptions.permissionerror
  }
  return GuiOptions.user
}

export {
  GuiOptions,
  asGuiOptions
}
